/*! @azure/msal-common v12.0.0 2023-04-03 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "12.0.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
